
import { IPhone } from "../models";

/**
 * Class for phone number normalization
 */
export class Phone implements IPhone {

    _phone: string;
    _isValid: boolean;

    NOT_NUMBER_SYMBOLS = /[()_-\s+]+/g;

    // Not normalized like "(848) 208-8967"
    NOT_NORMALIZED_PHONE = /\([0-9]{3}\)[ ]{0,1}[0-9]{3}\-[0-9]{4}/;
    NORMALIZED_PHONE_PARTS = /([0-9]{3})([0-9]{3})([0-9]{4})/;

    constructor(phone: string) {

        if (!this.isAnyStylePhone(phone)) {
            // console.error(`Phone "${phone}" is not valid`);
            this._isValid = false;
        }
        if (!this.isPhoneNumber(phone)) {
            // console.error(`String "${phone}" is not phone number`);
            this._isValid = false;
        }

        this._phone = phone;
        this._isValid = true;
    }

    /**
     * Human friendly phone formatter.
     * Format: (848) 208-8967
     */
    friendly(): string {
        const withoutCode = this.simplePhone(this._phone);
        const parts = withoutCode.match(this.NORMALIZED_PHONE_PARTS);

        if (parts) {
            return `(${parts[1]}) ${parts[2]}-${parts[3]}`
        }

        // console.error(`String "${this._phone}" is not user friendly format`);
        return this._phone;
    }

    /**
     * Machne friendly phone formatter.
     * Format: +18482088967
     */
    normalized(): string {
        return `+1${this.cleanPhoneWithoutCountryCode(this.simplePhone(this._phone))}`;
    }

    isValid(): boolean {
        return this._isValid;
    }

    //----------------------------------------
    // TODO: need to implement
    isEquals(phone: string): boolean { return false; }

    // TODO: need to implement
    /**
     * Machne friendly phone as number type.
     * Return Number(18482088967) instead of String('+18482088967')
     */
    number(): number { return 0;}
    //----------------------------------------

    private isAnyStylePhone(phone: string = '') {
        const isNotNormalizedPhine = this.NOT_NORMALIZED_PHONE.test(phone);
        const isNormalizedPhine = this.NORMALIZED_PHONE_PARTS.test(phone);

        return isNotNormalizedPhine || isNormalizedPhine;
    }

    private isPhoneNumber(str: string) {
        let formatted = this.cleanPhoneWithoutCountryCode(this.simplePhone(str));
        return formatted.length === 10;
    }

    private simplePhone = (phone: string) => {
        return phone.replace('+1', '')
    }

    private cleanPhoneWithoutCountryCode(phone: string) {
        return phone ? phone.replace(this.NOT_NUMBER_SYMBOLS, '') : '';
    }

};
